import ReportMachine from "./ReportMachine";
export default ReportMachine;